import {KontStammStateType} from 'module/KontStamm/KontStammReducer'

export const selKontStammByPersNr = (state: KontStammStateType) => state.KontStamm.byPersNr